import { X } from '@/lib/socialProfile';

/**
 * Mapping of social network to required analytics fields for media cards
 * These fields are requested from ANALYTICS_V2 endpoint when lazy loading analytics
 */
export const ANALYTICS_POST_FIELDS: Record<string, string[]> = {
    [X]: ['like_count', 'reply_count', 'retweet_count']
    // Add other networks as needed
};
